/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {getRoute} from '@/routes/RouteDefinitions';
import {Page} from '@/types/pages';

export interface HasPageProps {
  pages: Page[];
  uri: string;
}

/**
 * Helper method to convert nested routes to 1D array url strings.
 */
const getRoutes = (pages) => {
  const authorized = pages.filter(({isAuthorized}) => isAuthorized);
  return authorized.map(({route, pages: childPages}) => (
    childPages ? getRoutes(childPages) : getRoute(route)
  )).flat();
};

/**
 * Utility method to compare if url mathes with the given pages.
 * ```typescript
 *  import {hasPage} from '@/security/helpers';
 * const isPermittedPages = hasPage(pages, '/tracking');
 * ```
 */
export const hasPage = ({
  pages,
  uri
}: HasPageProps): boolean => {
  return getRoutes(pages)?.includes(uri);
};
